// The example selector, on the demo site and nowhere else.
//
// Gated on the build rather than on a query parameter, because a parameter is
// something anyone can add to a production URL and this must never be reachable
// from a client-facing deployment. The demo build sets VITE_DEMO at compile
// time, so on any other build this component is never rendered and the
// fixtures are never imported into a session.
//
// It says what it is in the first three words. A demo of a financial assessment
// showing invented figures is only safe while nobody can mistake it for a real
// one, so the label is not decoration.

export default function DemoExampleBar({ households, current, onSelect, onReset, note }) {
  const list = households || [];
  const selected = list.find(h => h.id === current);

  return (
    <div className="conv-demobar no-print">
      <span className="conv-demobar-tag">Sample data &middot; simulated examples</span>

      <label className="conv-demobar-pick">
        Try an example
        <select value={current} onChange={e => onSelect(e.target.value)}>
          <optgroup label="Questionnaire only, no statements">
            {list.filter(h => !h.hasAnalysis).map(h => (
              <option key={h.id} value={h.id}>{h.label}</option>
            ))}
          </optgroup>
          <optgroup label="With portfolio analysis">
            {list.filter(h => h.hasAnalysis).map(h => (
              <option key={h.id} value={h.id}>{h.label}</option>
            ))}
          </optgroup>
        </select>
      </label>

      {selected?.note ? <span className="conv-demobar-note">{selected.note}</span> : null}
      {note ? <span className="conv-demobar-note">{note}</span> : null}

      <button type="button" className="conv-btn" onClick={onReset}>
        Reset this example
      </button>
    </div>
  );
}
